export { GraySpan } from './gray-span';
